'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var googleImagesApiMaxPixels = 2000;
var googleImagesApiUrlPattern = /^https?:\/\/(.+)\.(googleusercontent|ggpht)\.com\/(.+)$/;

var wixMediaPlatformMaxPixels = 5100; // Actually, width*height must be <= (5100)^2
var wixMediaPlatformUrlPattern = /^https?:\/\/(media\.wixapps\.net|.+\.wixmp\.com)\/(.+)\/images\/(.+)\/$/;
var wixMediaManagerUrlPattern = /^https?:\/\/static\.wixstatic\.com\/media\/(.+)$/;
var deprecatedMediaPlatformUrlPattern = /^https?:\/\/media\.wixapps\.net\//;
var newWixMediaPlatformUrlPattern = 'https://images-wixmp-190fec74f1fdb50de9162c9d.wixmp.com/';
var deprecatedMediaPlatformUrlPattern2 = /^https?:\/\/images-rest\.wixmp\.com\//;

function getUsmString(_ref) {
    var amount = _ref.amount,
        radius = _ref.radius,
        threshold = _ref.threshold;

    if (typeof amount === 'number' && typeof radius === 'number' && typeof threshold === 'number') {
        return ',usm_' + amount.toFixed(2) + '_' + radius.toFixed(2) + '_' + threshold.toFixed(2);
    }

    return '';
}

exports.default = {

    /**
     * @param width    Resized image width, 0 means max size.
     * @param height   Resized image height, 0 means max size.
     */
    fill: function fill() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref2$url = _ref2.url,
            url = _ref2$url === undefined ? null : _ref2$url,
            _ref2$width = _ref2.width,
            width = _ref2$width === undefined ? 0 : _ref2$width,
            _ref2$height = _ref2.height,
            height = _ref2$height === undefined ? 0 : _ref2$height,
            _ref2$usm = _ref2.usm,
            usm = _ref2$usm === undefined ? {} : _ref2$usm,
            _ref2$webpEnabled = _ref2.webpEnabled,
            webpEnabled = _ref2$webpEnabled === undefined ? false : _ref2$webpEnabled;

        if (!url) {
            return null;
        }

        var size = Math.max(width, height);

        var usmString = getUsmString(usm);

        if (googleImagesApiUrlPattern.test(url)) {
            return url + '=s' + (size >= 0 && size <= googleImagesApiMaxPixels ? size : 0);
        }

        if (wixMediaManagerUrlPattern.test(url)) {
            var extension = url.match(/\.[0-9A-z]+$/) || '.jpg';
            var filename = webpEnabled ? 'file.webp' : 'file' + extension;
            return width > 0 && height > 0 && width <= wixMediaPlatformMaxPixels && height <= wixMediaPlatformMaxPixels ? url + '/v1/fill/w_' + width + ',h_' + height + usmString + '/' + filename : url;
        }

        if (deprecatedMediaPlatformUrlPattern.test(url)) {
            // Following https://jira.wixpress.com/browse/RST-2829 - replacing with new URL and removing the slash / at the end of the URL.
            var newUrl = url.replace(deprecatedMediaPlatformUrlPattern, newWixMediaPlatformUrlPattern);
            if (newUrl.endsWith("/")) {
                newUrl = newUrl.slice(0, -1);
            }
            return newUrl;
        }

        if (deprecatedMediaPlatformUrlPattern2.test(url)) {
            // Following https://jira.wixpress.com/browse/RST-2829 - replacing with new URL and removing the slash / at the end of the URL.
            var newUrl2 = url.replace(deprecatedMediaPlatformUrlPattern2, newWixMediaPlatformUrlPattern);
            if (newUrl2.endsWith("/")) {
                newUrl2 = newUrl2.slice(0, -1);
            }
            return newUrl2;
        }

        if (wixMediaPlatformUrlPattern.test(url)) {
            // Media platform we always return the URL since they have weird issues, for example:
            // https://images-rest.wixmp.com/tenant_admin/images/15e7624ee3ee4eeaaaaec9e6175fcdb6~mv2/v1/fill/w_245,h_184/file.jpg
            // https://images-rest.wixmp.com/tenant_admin/images/15e7624ee3ee4eeaaaaec9e6175fcdb6~mv2/v1/fill/w_1084,h_722/file.jpg
            return url;
        }

        return url;
    },
    fillSharp: function fillSharp() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            url = _ref3.url,
            width = _ref3.width,
            height = _ref3.height,
            _ref3$webpEnabled = _ref3.webpEnabled,
            webpEnabled = _ref3$webpEnabled === undefined ? false : _ref3$webpEnabled;

        return this.fill({ url: url, width: width, height: height, usm: { amount: 1.20, radius: 1.00, threshold: 0.01 }, webpEnabled: webpEnabled });
    }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-restaurants-js-sdk/dist/helpers/Image.js
// module id = 896
// module chunks = 0